import axios from 'axios'
import { generateToken } from '../utils'

const levelUpRank = async ({
  contractAddress,
  editSecret,
  invoker,
  chain,
}: {
  contractAddress: string
  editSecret?: string
  invoker: string
  chain: number
}) => {
  if (!editSecret) return
  const token = await generateToken(contractAddress, editSecret || '')
  const URL = `${process.env.REACT_APP_STORAGE_URL}/task/level-up`
  const res = await axios.post(
    URL,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
        invoker,
        contract: contractAddress,
        chain,
      },
    }
  )
  return res.data
}
export default levelUpRank
